import React from 'react' 

import { editor } from './Editor.module.scss'

const Editor = ({ 
  explorer,
  param: {
    required,
    key,
    namespace,
    id,
    location,
    example
  }
}) => (
  <>
    { explorer?.enabled && (
      <input 
        className={editor}
        type='text'
        defaultValue={required ? example : null}
        required={required}
        placeholder={example}
        autoFocus={explorer.fieldNeedsFocus(id)}
        tabIndex='1'
        onChange={({ target: { value }}) => explorer.setParam(location, namespace, key, value)} 
      /> 
    )}
  </>
)

export default Editor